export default __webpack_public_path__ + "static/media/mindfulness.f30b02be.jpg";